import React from 'react';

const PhysicalInfo = () => {
    return (
        <div>
            <div className="hero p-10 bg-base-200 container mx-auto">
                <div className="hero-content text-center">
                    <div className="max-w-md">
                        <h1 className="text-5xl font-bold">Physical Examination</h1>
                        <p className="py-6">It measures important vital signs -- temperature, <br/>  blood pressure,and heart rate -- and evaluates your body using observation, <br/> palpitation, percussion, and auscultation.</p>
                        <p>ALso I provide various kinds of other medical services...</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhysicalInfo;